"use client";

import type { LeaderboardHighlightCardProps } from "./leaderboard-highlight-card.types";
export type { LeaderboardHighlight, LeaderboardHighlightCardProps } from "./leaderboard-highlight-card.types";
import { cn } from "../../lib/utils";
import {
  getLeaderboardInitials,
  LeaderboardDisplayName,
} from "./leaderboard-identity";
import { ProfileAvatar } from "./profile-avatar";





export function LeaderboardHighlightCard({
  creators,
  className,
}: LeaderboardHighlightCardProps) {
  // Always maintain 3 slots: [Rank 2, Rank 1, Rank 3]
  const rank1 = creators.find((c) => c.position === 1);
  const rank2 = creators.find((c) => c.position === 2);
  const rank3 = creators.find((c) => c.position === 3);

  const podiumSlots = [
    { position: 2, data: rank2 },
    { position: 1, data: rank1 },
    { position: 3, data: rank3 },
  ];

  return (
    <div
      className={cn(
        "rounded-lg border border-black bg-white px-3 py-3 shadow-[0_4px_0_0_#000000]",
        className
      )}
    >
      <div className="flex items-end justify-between gap-4 text-center text-[#344054]">
        {podiumSlots.map((slot, index) => {
          const creator = slot.data;
          if (!creator) {
            return <div key={`empty-${index}`} className="flex-1" />;
          }

          return (
            <div
              key={creator.id}
              className={cn(
                "relative flex flex-1 flex-col items-center gap-1",
                creator.position === 1 ? "pb-7" : "pb-0"
              )}
            >
              <div className="relative h-12 w-12">
                <ProfileAvatar
                  src={creator.avatar}
                  alt={creator.isAnonymous ? "Anonymous creator avatar" : creator.name}
                  className="h-12 w-12 rounded-full border border-black"
                  fallbackClassName="bg-[#F2F4F7] text-sm font-semibold text-[#344054]"
                  logoClassName="h-[54%] w-[54%]"
                  fallback={<span>{getLeaderboardInitials(creator.name)}</span>}
                />
                {creator.medalIcon && (
                  <span className="absolute -right-2 -top-2 h-6 w-6">
                    {creator.medalIcon}
                  </span>
                )}
                {!creator.medalIcon && (
                  <span className="absolute -right-2 -top-2 flex h-6 w-6 items-center justify-center rounded-full border border-black bg-white text-xs font-semibold">
                    {creator.position}
                  </span>
                )}
              </div>
              <LeaderboardDisplayName
                name={creator.name}
                isAnonymous={creator.isAnonymous}
                className="text-sm font-medium text-[#344054]"
              />
              <p className="text-sm font-medium text-[#98A2B3]">
                {creator.followers}
              </p>
              <p className="text-base font-semibold text-[#ED5AA9]">
                {creator.earnings}
              </p>
              {creator.members !== undefined && (
                <p className="text-xs font-medium text-[#475467]">
                  {creator.members} {creator.members === 1 ? "Member" : "Members"}
                </p>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
